import DentistsMapOnboard from './DentistsMapOnboard';

export default DentistsMapOnboard;
